import {EditorConfig} from '../../../constants/editorConfig'
import {removeNodes} from '../../../editorActions'

const InteractionMode = EditorConfig.INTERACTION_MODES

/**
 * Bind keyboard shortcuts.
 */
export function bindKeyboardInput(editor, stage, interaction, {isTextEditing} = {}) {
    let currentMode = InteractionMode.IDLE
    /** @param {KeyboardEvent} e */
    function onKeyDown(e) {
        if (isTextEditing?.()) return

        if (e.key === EditorConfig.KEYBOARD.DELETE_KEY) {
            editor.dispatch(removeNodes(editor.getState().selection.nodeIds))
        }

        if ((e.ctrlKey || e.metaKey) && e.key === EditorConfig.KEYBOARD.UNDO_KEY) {
            editor.undo()
        }

        if ((e.ctrlKey || e.metaKey) && e.key === EditorConfig.KEYBOARD.REDO_KEY) {
            editor.redo()
        }

        if (e.code === EditorConfig.KEYBOARD.PAN_KEY_CODE && !interaction.is(InteractionMode.PAN)) {
            interaction.setMode(InteractionMode.PAN)
            stage.draggable(true)
            stage.container().style.cursor = EditorConfig.KEYBOARD.PAN_CURSOR_ACTIVE
        }
    }

    function onKeyUp(e) {
        if (e.code === EditorConfig.KEYBOARD.PAN_KEY_CODE) {
            interaction.reset()
            stage.draggable(false)
            stage.container().style.cursor = EditorConfig.KEYBOARD.PAN_CURSOR_INACTIVE
        }
    }

    window.addEventListener('keydown', onKeyDown)
    window.addEventListener('keyup', onKeyUp)

    return function unbind() {
        window.removeEventListener('keydown', onKeyDown)
        window.removeEventListener('keyup', onKeyUp)
    }
}
